const appName = "patientportal.100plus";
const getKey = (key) => `${appName}.${key}`;

export const set = (key, value) => localStorage.setItem(getKey(key), value);
export const get = (key) => localStorage.getItem(getKey(key));
export const remove = (key) => localStorage.removeItem(getKey(key));
